import React from 'react';
import { hostIsCapreit, hostIsCapreitERES } from 'helpers/CurrentWindowLocation';

const styles = {
  page: {
    textAlign: 'center',
    marginTop: '50px',
    fontSize: '18px',
    padding: '1rem',
  },
  errorImage: {
    maxWidth: '300px',
    width: '50%',
    height: 'auto',
  },
  h1: {
    fontSize: '20px',
  },
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      info: null,
      returnUrl: window.location.pathname.startsWith('/companies') ? '/companies/dashboard' : '/',
    };
  }
  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      error: error,
      info: info,
    });
    window.Rollbar.error(error);
  }

  companyContactEmail = () => {
    if (hostIsCapreitERES()) return 'technischbeheer@eresm.nl';
    if (hostIsCapreit()) return 'operations@capreit.net';
    else return 'help@yuhu.io';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.page}>
          <img style={styles.errorImage} src="/broken_laptop.svg" alt="Something went wrong!" />
          <h1 style={styles.h1}>Oops! Something went wrong!</h1>
          <p>{`Please try again at a later time, or email us at ${this.companyContactEmail()}`}</p>
          <a href={this.state.returnUrl}>&larr; Go Back</a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
